import { useBreadcrumbs } from '@shared/lib';
import { useEffect } from 'react';
import { UserBreadcrumbs } from '@features/user';
import { RESPONSIBLE_USER_ID_SEARCH_PARAM } from '@features/vacancy';
import { WithFallback } from '@shared/ui';
import { useGetUser } from '@entities/user';
import { useShowMe } from '@entities/auth';
import { useNavigate, useParams } from 'react-router';
import { ROLES } from '@shared/constants';
import { UserInfo } from './components/user-info';

const getUserVacanciesHref = (userId: number) => {
  const searchParams = new URLSearchParams({
    [RESPONSIBLE_USER_ID_SEARCH_PARAM]: userId.toString(),
    opened: 'true',
  });

  return `/vacancy-list?${searchParams.toString()}`;
};

export const UserPage = () => {
  const { data: me } = useShowMe();

  const { id } = useParams();
  const navigate = useNavigate();

  const { data: user, isFetching: isUserFetching } = useGetUser(id || '');

  const context = useBreadcrumbs();

  useEffect(() => {
    const firstName = user?.profile.firstName;
    const lastName = user?.profile.lastName;

    if (!context || !firstName || !lastName) {
      return;
    }

    context.setBreadcrumb(
      <UserBreadcrumbs subPage={`${firstName} ${lastName}`} />
    );

    return () => {
      context.clearBreadcrumb();
    };
  }, [user?.profile.firstName, user?.profile.lastName]);

  // Кейс, когда саппорт по прямой ссылке пытается посмтреть деталку админа
  useEffect(() => {
    if (!user || isUserFetching) {
      return;
    }
    const isPrivateRole =
      user.role?.name === ROLES.ADMIN || user.role?.name === ROLES.SUPPORT;

    if (isPrivateRole && me?.role.name !== ROLES.ADMIN) {
      navigate('/');
    }
  }, [user, isUserFetching]);

  return (
    <WithFallback data={user} isLoading={isUserFetching}>
      {user => (
        <UserInfo user={user} viewAllHref={getUserVacanciesHref(user.id)} />
      )}
    </WithFallback>
  );
};
